import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { borderRadius, breakpoint, size } from '@twisto/styles'

export const root = (theme: Theme) => css`
  border: 1px solid ${theme.palette.neutral[300]};
  border-radius: ${borderRadius.sm};
  padding: ${size[24]};
  margin-bottom: ${size[32]};
`

export const row = css`
  column-gap: ${size[12]};
  margin-top: ${size[12]};

  ${breakpoint.up('sm')} {
    margin-top: ${size[16]};
  }
`
